export default __webpack_public_path__ + "74875357e6bfe9a35eacbdae63837b56.png";